
import React, { useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import HTMLPage from './components/HTMLPage';
import './App.css';

function App() {
  // 初始化折叠状态
  const [collapsed, setCollapsed] = useState({

    
      'fai': true,
    
      'ml': true,
    
      'dl': true,
    
      'aied': true,
    

  });

  // 切换折叠状态的函数
  const toggleCollapse = (category) => {
    setCollapsed(prevState => ({
      ...prevState,
      [category]: !prevState[category]  // 切换折叠/展开状态
    }));
  };

  return (
    <div className="app">
      <nav className="sidebar">
        <h2>Navigation</h2>
        <ul>

          

          <li>
            <button onClick={() => toggleCollapse('fai')}>
              {collapsed[`fai`] ? '▶' : '▼'} {`FAI`}
            </button>
            {!collapsed[`fai`] && (
              <ul>

                

                <li><Link to={`/fai/FAI_-_CSP概念及其解`}>{`FAI_-_CSP概念及其解`}</Link></li>

                

                <li><Link to={`/fai/FAI_-_搜索结尾`}>{`FAI_-_搜索结尾`}</Link></li>

                

                <li><Link to={`/fai/FAI_-_Search_Problem_Deep_Dive`}>{`FAI_-_Search_Problem_Deep_Dive`}</Link></li>

                

              </ul>
            )}
          </li>

          

          <li>
            <button onClick={() => toggleCollapse('ml')}>
              {collapsed[`ml`] ? '▶' : '▼'} {`ML`}
            </button>
            {!collapsed[`ml`] && (
              <ul>

                

                <li><Link to={`/ml/ML-Ensemble_Method_集成方法`}>{`ML-Ensemble_Method_集成方法`}</Link></li>

                

                <li><Link to={`/ml/ML-线性回归解释与翻译`}>{`ML-线性回归解释与翻译`}</Link></li>

                

              </ul>
            )}
          </li>

          

          <li>
            <button onClick={() => toggleCollapse('dl')}>
              {collapsed[`dl`] ? '▶' : '▼'} {`DL`}
            </button>
            {!collapsed[`dl`] && (
              <ul>

                

                <li><Link to={`/dl/DL_-_梯度下降算法`}>{`DL_-_梯度下降算法`}</Link></li>

                

                <li><Link to={`/dl/DL_-_泛化能力`}>{`DL_-_泛化能力`}</Link></li>

                

                <li><Link to={`/dl/DL_-_梯度下降算法 (2)`}>{`DL_-_梯度下降算法 (2)`}</Link></li>

                

              </ul>
            )}
          </li>

          

          <li>
            <button onClick={() => toggleCollapse('aied')}>
              {collapsed[`aied`] ? '▶' : '▼'} {`AIED`}
            </button>
            {!collapsed[`aied`] && (
              <ul>

                

                <li><Link to={`/aied/AIED-以人为中心的学习分析`}>{`AIED-以人为中心的学习分析`}</Link></li>

                

                <li><Link to={`/aied/AIED-人工智能在教育中的应用`}>{`AIED-人工智能在教育中的应用`}</Link></li>

                

              </ul>
            )}
          </li>

          

        </ul>
      </nav>
      <main className="content">
        <Routes>

          
            

            <Route path="/fai/FAI_-_CSP概念及其解" element={<HTMLPage filePath={`/html_files/FAI_-_CSP概念及其解.html`} />} />

            

            <Route path="/fai/FAI_-_搜索结尾" element={<HTMLPage filePath={`/html_files/FAI_-_搜索结尾.html`} />} />

            

            <Route path="/fai/FAI_-_Search_Problem_Deep_Dive" element={<HTMLPage filePath={`/html_files/FAI_-_Search_Problem_Deep_Dive.html`} />} />

            
          
            

            <Route path="/ml/ML-Ensemble_Method_集成方法" element={<HTMLPage filePath={`/html_files/ML-Ensemble_Method_集成方法.html`} />} />

            

            <Route path="/ml/ML-线性回归解释与翻译" element={<HTMLPage filePath={`/html_files/ML-线性回归解释与翻译.html`} />} />

            
          
            

            <Route path="/dl/DL_-_梯度下降算法" element={<HTMLPage filePath={`/html_files/DL_-_梯度下降算法.html`} />} />

            

            <Route path="/dl/DL_-_泛化能力" element={<HTMLPage filePath={`/html_files/DL_-_泛化能力.html`} />} />

            

            <Route path="/dl/DL_-_梯度下降算法 (2)" element={<HTMLPage filePath={`/html_files/DL_-_梯度下降算法 (2).html`} />} />

            
          
            

            <Route path="/aied/AIED-以人为中心的学习分析" element={<HTMLPage filePath={`/html_files/AIED-以人为中心的学习分析.html`} />} />

            

            <Route path="/aied/AIED-人工智能在教育中的应用" element={<HTMLPage filePath={`/html_files/AIED-人工智能在教育中的应用.html`} />} />

            
          

        </Routes>
      </main>
    </div>
  );
}

export default App;
